export default {
  label: "Язык",
  options: {
    en: "Английский",
    ru: "Русский",
  },
};
